import { BaseLayerConfig, BaseLayerType } from 'types/app.types';
import LayerName from 'contexts/MapViewContext/hooks/enums';
import ARENALayerConfig from './connectedLayersConfig/ARENA';

const baseLayers : BaseLayerConfig[] = [
  {
    level: 1,
    layerName: LayerName.BaseMapLayer,
    name: 'Default base layer',
    defaultSelected: true,
    tiled: false,
    minZoom: 1,
    type: 'label',
  },
  {
    level: 2,
    layerName: LayerName.BaseMapLayerWithLabels,
    name: 'Labels (Countries and populated places)',
    defaultSelected: false,
    tiled: false,
    minZoom: 1,
    type: 'label',
  },
  {
    level: 9,
    layerName: LayerName.ARENALayer,
    name: 'ARENA',
    defaultSelected: !localStorage.getItem('isARENALayerEnabled') ? true : localStorage.getItem('isARENALayerEnabled') === 'true',
    tiled: false,
    minZoom: 3,
    type: 'aux',
    connected: true,
    config: ARENALayerConfig,
  },
  {
    level: 10,
    layerName: LayerName.CTRLayer,
    name: 'CTR',
    defaultSelected: !localStorage.getItem('isCTRLayerEnabled') ? true : localStorage.getItem('isCTRLayerEnabled') === 'true',
    tiled: false,
    minZoom: 3,
    type: 'aux',
  },
  {
    level: 12,
    layerName: LayerName.FIRLayer,
    name: 'FIR',
    defaultSelected: localStorage.getItem('isFIRLayerEnabled') === 'true',
    tiled: false,
    minZoom: 3,
    type: 'aux',
  },
  {
    level: 11,
    layerName: LayerName.Coastline,
    name: 'Coastline',
    defaultSelected: localStorage.getItem('isCoaslineLayerEnabled') === 'true',
    tiled: false,
    minZoom: 3,
    type: 'label',
  },
];

const getFilteredBaseLayers = () => baseLayers.reduce<Record<BaseLayerType, BaseLayerConfig[]>
| never>((acc, cur) => {
  acc[cur.type] = [...acc[cur.type] || [], cur];
  return acc;
}, {} as never);

export { getFilteredBaseLayers };
export default baseLayers;
